import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useModalKeyTrap } from '../../hooks/useModalKeyTrap';
import type { LicenseVerificationPhase } from '../../contexts/DeviceContext';
import './LicenseVerificationModal.css';

interface Props {
  phase: Exclude<LicenseVerificationPhase, 'healthy'>;
  onContinue: () => void;
  onBack: () => void;
}

const LicenseVerificationModal: React.FC<Props> = ({ phase, onContinue, onBack }) => {
  const { t } = useTranslation();
  const recovered = phase === 'recovered';

  useModalKeyTrap(useCallback((key, event) => {
    event.preventDefault();
    if (!recovered) return;
    if (key === 'Enter' || key === 'Space' || key === 'MediaPlay' || key === 'MediaPlayPause') {
      onContinue();
    } else if (key === 'Back') {
      onBack();
    }
  }, [onBack, onContinue, recovered]));

  return (
    <div className="license-verification__overlay" role="dialog" aria-modal="true">
      <div className="license-verification__box">
        <div className="license-verification__title">
          {recovered
            ? t('licenseVerification.restoredTitle', 'Conexão restaurada')
            : t('licenseVerification.unavailableTitle', 'Verificação indisponível')}
        </div>
        <div className="license-verification__message">
          {recovered
            ? t('licenseVerification.restoredBody', 'Pressione Play ou OK para continuar.')
            : t('licenseVerification.unavailableBody', 'A reprodução foi pausada. Tentaremos conectar novamente automaticamente.')}
        </div>
        {recovered && (
          <button className="license-verification__button" autoFocus onClick={onContinue}>
            {t('licenseVerification.continue', 'Continuar')}
          </button>
        )}
      </div>
    </div>
  );
};

export default LicenseVerificationModal;
